<template>
  <div class="download">
    <h3>Télécharger <small>(Global)</small></h3>

    <div class="downloads">
      <a
        class="btn btn--android"
        href="https://play.google.com/store/apps/details?id=com.miHoYo.bh3global"
        rel="nofollow noopener noreferrer"
        target="_blank"
      >
        <span><GoogleplayIcon class="simple-icons" /> Play Store</span></a>
      <a
        class="btn btn--apk"
        href="https://sg-public-api.hoyoverse.com/event/download_porter/link/bh3_os/galobalapk/default"
        rel="nofollow noopener noreferrer"
        target="_blank"
      >
        <span><AndroidIcon class="simple-icons" /> APK</span></a>
      <a
        class="btn btn--ios"
        href="https://apps.apple.com/app/id1336342304"
        rel="nofollow noopener noreferrer"
        target="_blank"
      >
        <span><AppstoreIcon class="simple-icons" /> App Store</span></a>
      <br>
      <a
        class="btn btn--windows"
        href="https://sg-public-api.hoyoverse.com/event/download_porter/link/bh3_os/pcglobal/default"
        rel="nofollow noopener noreferrer"
        target="_blank"
      >
        <span><DownloadIcon
          class="simple-icons"
          role="img"
        /> Launcher PC</span></a>
      <a
        class="btn btn--epic-games"
        href="https://store.epicgames.com/fr/p/honkai-impact-3rd"
        rel="nofollow noopener noreferrer"
        target="_blank"
      >
        <span><EpicgamesIcon class="simple-icons" /> Epic Games</span></a>
      <a
        class="btn btn--steam"
        href="https://store.steampowered.com/app/1671200/Honkai_Impact_3rd/"
        rel="nofollow noopener noreferrer"
        target="_blank"
      >
        <span><SteamIcon class="simple-icons" /> Steam</span></a>
    </div>
  </div>
</template>

<script lang="ts" setup>
// Icons
import {
  AndroidIcon,
  AppstoreIcon,
  EpicgamesIcon,
  GoogleplayIcon,
  SteamIcon,
} from '@mkody/vue3-simple-icons'
import DownloadIcon from '@/components/download.svg?component'
</script>

<style scoped lang="scss">
.download {
  margin-bottom: 2em;

  .downloads {
    line-height: 1.5em;

    .btn {
      background-color: rgba(0, 0, 0, 0.6);
      background-image: url('/img/grid.png');
      background-repeat: repeat;
      border-image-slice: 6;
      border-image-source: url('/img/border-btn.svg');
      border-style: solid;
      border-width: 4px;
      color: #fff;
      display: inline-block;
      margin-bottom: .5em;
      margin-right: .5em;
      text-align: center;
      text-decoration: none;

      &:visited {
        color: inherit;
      }

      &:hover > span {
        background-color: #fff;
        background-image: url('/img/grid.png');
        background-repeat: repeat;
        color: #000;
      }

      @media screen and (min-width: 420px) {
        &--android {
          border-right: none;
          margin-right: 0;
        }

        &--apk {
          border-left: none;
        }

        &--windows {
          border-right: none;
          margin-right: 0;
        }

        &--epic-games {
          border-left: none;
          border-right: none;
          margin-right: 0;
        }

        &--steam {
          border-left: none;
        }
      }

      span {
        display: inline-block;
        padding: 5px 10px;

        & > svg {
          height: 1rem;
          width: auto;
        }
      }
    }
  }
}
</style>
